<template>
  <div class="contenedor">
    <div class="logo-nav" :class="{ 'logo-nav-admin': esAdmin }">
      <router-link to="/">
        <Logo logoWidth="16vw" logoHeight="auto" data-aos="fade-right" />
      </router-link>
      <nav class="nav" :class="{ displayNone: esAdmin }">
        <router-link to="/" active-class="active-link">Inicio</router-link>
        <router-link :to="{ path: '/', hash: '#sobre-nosotros' }">Sobre nosotros</router-link>
        <router-link to="/catalogo" active-class="active-link">Catálogo</router-link>
        <div ref="suscripcion" class="suscripcion-container">
          <button class="routerLink botonEspecial" @click="toggleMenu">
            Suscripción
          </button>

          <div v-if="mostrarMenu" class="menu-suscripcion">
            <router-link to="/suscripcion/pago-unico" @click="goToAndClose('/suscripcion/pago-unico')">Plan pago
              único</router-link>

            <router-link to="/suscripcion/mensual" @click="goToAndClose('/suscripcion/mensual')">Suscripción
              mensual</router-link>
          </div>
        </div>
        <router-link to="/nuestros-eventos" active-class="active-link">Eventos</router-link>
        <router-link :to="{ path: '/', hash: '#contacto' }">Contacto</router-link>
      </nav>
      <!-- Menu Hamburguesa -->
      <div class="contenedorMenuHabmburguesa" :class="{ displayNone: esAdmin }">
        <button class="btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-list"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
          </svg>
        </button>

        <div ref="offcanvas" class="offcanvas offcanvas-end" style="width: 300px" tabindex="-1" id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasRightLabel">MENÚ</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
              aria-label="Close"></button>
          </div>
          <div class="offcanvas-body">
            <router-link class="routerLink" to="/" @click.prevent="closeOffcanvas({ path: '/' })">Inicio</router-link>
            <router-link class="routerLink" :to="{ path: '/', hash: '#sobre-nosotros' }" @click.prevent="
              closeOffcanvas({ path: '/', hash: '#sobre-nosotros' })
              ">Sobre nosotros</router-link>
            <router-link class="routerLink" to="/catalogo"
              @click.prevent="closeOffcanvas({ path: '/catalogo' })">Catálogo</router-link>
            <router-link class="routerLink" to="/nuestros-eventos"
              @click.prevent="closeOffcanvas({ path: '/nuestros-eventos' })">Eventos</router-link>
            <router-link class="routerLink" to="/suscripcion/pago-unico"
              @click.prevent="closeOffcanvas({ path: '/suscripcion/pago-unico' })">Plan pago único</router-link>

            <router-link class="routerLink" to="/suscripcion/mensual"
              @click.prevent="closeOffcanvas({ path: '/suscripcion/mensual' })">Suscripción mensual</router-link>
            <router-link class="routerLink" :to="{ path: '/', hash: '#contacto' }"
              @click.prevent="closeOffcanvas({ path: '/', hash: '#contacto' })">Contacto</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/Logo.vue";
export default {
  name: "BarraNavegacion",
  components: {
    Logo,
  },
  data() {
    return {
      mostrarMenu: false,
      offcanvas: null,
    };
  },
  computed: {
    esAdmin() {
      return (
        this.$route.path === "/iniciar-sesion" ||
        this.$route.path === "/:catchAll(.*)" ||
        this.$route.path.startsWith("/admin")
      );
    },
  },

  mounted() {
    this.offcanvas = new bootstrap.Offcanvas(
      document.getElementById("offcanvasRight")
    );
    // cerrar al click fuera y con Esc
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("keydown", this.handleEsc);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleEsc);
  },

  watch: {
    // cerrar si cambia la ruta
    $route() {
      this.mostrarMenu = false;
    },
  },

  methods: {
    toggleMenu() {
      this.mostrarMenu = !this.mostrarMenu;
    },

    // click fuera del contenedor de suscripción
    handleClickOutside(e) {
      if (!this.mostrarMenu) return;
      const el = this.$refs.suscripcion;
      if (el && !el.contains(e.target)) {
        this.mostrarMenu = false;
      }
    },

    handleEsc(e) {
      if (e.key === "Escape") this.mostrarMenu = false;
    },

    // navegar y cerrar el desplegable
    goToAndClose(path) {
      this.mostrarMenu = false;
      this.$router.push(path);
    },

    cerrarMenu() {
      this.mostrarMenu = false;
    },

    closeOffcanvas(route) {
      this.offcanvas.hide();
      setTimeout(() => this.$router.push(route), 300);
    },
  },
};
</script>

<style>
.logo-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.8rem;
}

.logo-nav-admin {
  justify-content: center;
  background-color: #ffffff;
}

nav {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 65px;
}

nav a,
.routerLink {
  font-family: "Cormorant Upright";
  font-style: normal;
  font-weight: 400;
  font-size: 26px;
  line-height: 31px;
  color: #000000;
  text-decoration: none;
  padding: 0.4vw;
}

.botonEspecial {
  border: none;
  color: black !important;
  background-color: transparent;
}

.botonEspecial:hover {
  color: white !important;
  background: #9a9797;
  border-radius: 1.5vw;
}

.nav a:hover,
.active-link {
  color: white;
  background: #9a9797;
  border-radius: 1.5vw;
}

.active-link {
  font-weight: 800;
}

.displayNone {
  display: none;
}

.offcanvas-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
}

.routerLink {
  color: #ffffff;
}

.offcanvas {
  background: #050505dd;
}

.contenedorMenuHabmburguesa {
  display: none;
}

.suscripcion-container {
  position: relative;
  display: inline-block;
}

.menu-suscripcion {
  position: absolute;
  top: 45px;
  left: -30px;
  background: white;
  padding: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 99999;
  width: 160%;
}

.menu-suscripcion a {
  font-family: "Poppins";
  font-size: 15px;
  display: block;
  padding: 0.3rem 0.5rem;
}

/* ajustes por pantalla */

@media screen and (max-width: 1000px) {
  .nav {
    display: none;
  }

  .contenedorMenuHabmburguesa {
    display: flex;
  }
}
</style>
